import { Reveal, Eyebrow } from "./Reveal";
import {
  PhoneMissed,
  MessageSquareText,
  ClipboardCheck,
  CalendarCheck2,
  BadgeCheck,
} from "lucide-react";

const stages = [
  { icon: PhoneMissed, label: "Missed Call" },
  { icon: MessageSquareText, label: "Reply Sent" },
  { icon: ClipboardCheck, label: "Qualified Lead" },
  { icon: CalendarCheck2, label: "Booked" },
  { icon: BadgeCheck, label: "Job Complete" },
];

const feed = [
  { time: "21:14", text: "Missed call (555) 882-0119 → SMS in 7s → emergency repair booked" },
  { time: "20:47", text: "Web lead re-engaged after 3 days → maintenance plan scheduled" },
  { time: "19:32", text: "Forgotten estimate $6,800 → follow-up sent → replacement quoted" },
];

export default function Pipeline() {
  return (
    <section data-testid="pipeline-section" className="border-t border-white/[0.06] py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow>Full Journey Tracking</Eyebrow>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
            Watch every dollar move through the pipeline
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-400">
            Backfill tracks the journey from missed call to completed job, so
            nothing falls into a spreadsheet graveyard.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="pipeline-tracker"
            className="relative mt-14 rounded-xl border border-white/[0.08] bg-[#12161F] px-6 py-10 sm:px-10"
          >
            <div className="relative">
              <div className="absolute left-0 right-0 top-6 h-px bg-white/[0.1]" />
              <div className="pipeline-runner absolute top-[23px] h-1.5 w-1.5 rounded-full bg-[#F25F22] shadow-[0_0_12px_rgba(242,95,34,0.9)]" />
              <div className="relative grid grid-cols-5">
                {stages.map((s, i) => (
                  <div key={s.label} className="flex flex-col items-center gap-3">
                    <div
                      data-testid={`pipeline-stage-${i}`}
                      className={`flex h-12 w-12 items-center justify-center rounded-full border bg-[#0B0D10] ${
                        i < 2
                          ? "border-[#F25F22]/60 shadow-[0_0_20px_rgba(242,95,34,0.25)]"
                          : "border-white/[0.12]"
                      }`}
                    >
                      <s.icon
                        className={`h-5 w-5 ${i < 2 ? "text-[#F25F22]" : "text-slate-400"}`}
                      />
                    </div>
                    <span className="text-center font-mono text-[10px] uppercase tracking-wider text-slate-400 sm:text-[11px]">
                      {s.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-10 space-y-2.5 border-t border-white/[0.06] pt-6">
              {feed.map((f, i) => (
                <div
                  key={i}
                  data-testid={`pipeline-feed-${i}`}
                  className="flex items-center gap-4 font-mono text-xs"
                >
                  <span className="shrink-0 text-[#F25F22]">{f.time}</span>
                  <span className="truncate text-slate-400">{f.text}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
